import { z } from 'zod';
import { defineListQuery, inForceFilter, listFilter } from './list-query.schemas';

/** Which truck a GPS installation's device is fitted to, over a period (gitaumoses4/chukua#84). */

const instantSchema = z.iso.datetime({ offset: true });

/** `effectiveFrom` defaults to now. A swap is a close of the old mapping and a new one, never an edit of the device. */
export const createDeviceMappingSchema = z.object({
  integrationId: z.uuid(),
  deviceId: z.string().trim().min(1).max(100),
  truckId: z.uuid(),
  effectiveFrom: instantSchema.optional(),
});
export type CreateDeviceMappingInput = z.infer<typeof createDeviceMappingSchema>;

/** The only edit: ending the period. Closing at its own `effectiveFrom` withdraws a mapping made by mistake. */
export const closeDeviceMappingSchema = z.object({ effectiveTo: instantSchema }).strict();
export type CloseDeviceMappingInput = z.infer<typeof closeDeviceMappingSchema>;

export interface DeviceMapping {
  id: string;
  integrationId: string;
  integrationName: string;
  deviceId: string;
  truckId: string;
  truckRegistration: string;
  effectiveFrom: string;
  effectiveTo: string | null;
}

export const deviceMappingListQuerySchema = defineListQuery({
  sortFields: ['deviceId', 'effectiveFrom', 'createdAt'],
  defaultSort: { sort: 'effectiveFrom', order: 'desc' },
  filters: {
    integrationId: listFilter(z.uuid()),
    truckId: listFilter(z.uuid()),
    current: inForceFilter,
  },
});
export type DeviceMappingListQuery = z.infer<typeof deviceMappingListQuerySchema>;
